<template>
  <div >
    <a-form-model :model="certForm" :rules="rules" ref="certForm">
      <template v-if="currentStep == 1">
        <div class="tip">
          <img src="~@/assets/images/deal-manage/depot_tip.png" class="tip-img">
          <span class="tip-title">为确认是您本人操作，请选择以下任一方式完成身份认证</span>
        </div>
        <div v-if="personalInfo.mobile" class="check-btn" @click="changeCert('mobile')">
          <img src="~@/assets/images/login/mobile.png" style="margin-left: 10px;margin-right: 8px;" />
          <span class="method">手机号验证</span>
          <span style="float: right;line-height: 60px;margin-right: 20px;font-size: 14px;color: #666666;">{{
            personalInfo.mobile }}</span>
        </div>
        <div v-if="personalInfo.email && source !='jd'" class="check-btn" @click="changeCert('email')">
          <img src="~@/assets/images/login/email.png" style="margin-left: 10px;margin-right: 8px;" />
          <span class="method">邮箱验证</span>
          <span style="float: right;line-height: 60px;margin-right: 20px;font-size: 14px;color: #666666;">{{
            personalInfo.email }}</span>
        </div>
        <div v-if="personalInfo.safe_state == 1 && source !='jd'" class="check-btn" @click="changeCert('question')">
          <img src="~@/assets/images/login/question.png" style="margin-left: 10px;margin-right: 8px;" />
          <span class="method">密保问题验证</span>
        </div>
      </template>
      <template v-else>
        <!-- <a-form-model-item v-if="!certType" label="选择验证身份方式">
          <a-select v-model="certMethod" :options="certMethods" @change="changeCertMethods"></a-select>
        </a-form-model-item> -->

        <section v-show="certMethod === 'mobile'">
          <a-form-model-item v-if="isInputMobile" label="手机号码" prop="mobile">
            <a-input v-model="certForm.mobile" placeholder="请输入手机号码" />
          </a-form-model-item>
          <a-form-model-item v-else label="手机号码">
            {{ personalInfo.mobile }}
          </a-form-model-item>
          <a-form-model-item label="手机验证码" prop="smsCode" ref="smsCode">
            <a-row :gutter="20">
              <a-col :span="17">
                <a-input v-model="certForm.smsCode" placeholder="请输入手机验证码" />
              </a-col>
              <a-col :span="5">
                <!-- <throttle-btn typeValue="mobile" key="mobile" :isValidate="isInputMobile" :mobile="certForm.mobile"
                @validate="validateMobile" ref="smsBtn" /> -->
                <throttle-btn key="mobile" isValidate @validate="validateMobile" ref="smsBtn" />
              </a-col>
            </a-row>
          </a-form-model-item>
        </section>

        <section v-show="certMethod === 'email'">
          <template v-if="personalInfo.email">
            <a-form-model-item label="已绑定邮箱">
              {{ personalInfo.email }}
            </a-form-model-item>
            <a-form-model-item label="邮箱验证码" prop="emailCode">
              <a-row :gutter="20">
                <a-col :span="17">
                  <a-input v-model="certForm.emailCode" placeholder="请输入邮箱验证码" />
                </a-col>
                <a-col :span="5">
                  <throttle-btn typeValue="email" defaultTitle="获取邮箱验证码" :time="300" key="email" :email="certForm.email" isValidate @validate="validateEmail" ref="emailBtn" />
                </a-col>
              </a-row>
            </a-form-model-item>
          </template>
          <template v-else>
            <a-form-model-item :wrapperCol="{ span: 24 }">
              <div class="btn_wrapper">
                <a-button type="link" @click="toBindEmail">您尚未绑定邮箱，请先绑定邮箱
                </a-button>
              </div>
            </a-form-model-item>
          </template>
        </section>

        <section v-show="certMethod === 'question'">
          <template v-if="questionList.length > 0">
            <template v-for="(question, index) in questionList">
              <a-form-model-item :label="`密保问题${index + 1}`" :key="`queston-${index + 1}`">
                {{ question.question }}
              </a-form-model-item>
              <a-form-model-item :label="`密保答案${index + 1}`" :key="`item-answer-${index + 1}`"
                :prop="`answer${index + 1}`">
                <a-input v-model="certForm[`answer${index + 1}`]" />
              </a-form-model-item>
            </template>
          </template>
          <template v-else>
            <a-form-model-item :wrapperCol="{ span: 24 }">
              <div class="btn_wrapper">
                <a-button type="link" @click="toSetQuestion">请先设置密保问题
                </a-button>
              </div>
            </a-form-model-item>
          </template>
        </section>

        <template v-if="hasImgCode">
          <a-form-model-item v-if="certMethod === 'mobile' || certMethod === 'email' && userInfo.email" label="图片验证码"
            prop="imgCode" ref="imgCodeField">
            <a-row :gutter="20">
              <a-col :span="17">
                <a-input v-model="certForm.imgCode" placeholder="请输入图片验证码" ref="imgCode" />
              </a-col>
              <a-col :span="6">
                <img :src="imgCode" @click="changeImgCode" alt="验证码" width="102" height="36" class="img_code" />
              </a-col>
            </a-row>
          </a-form-model-item>
        </template>
        <a-form-model-item
          v-if="certMethod === 'mobile' || certMethod === 'email' && personalInfo.email || certMethod === 'question'"
          :wrapperCol="{ span: 24 }">
          <div class="btn_wrapper mt20">
            <a-button @click="submit" type="primary">提交
            </a-button>
          </div>
        </a-form-model-item>
      </template>

    </a-form-model>

    <div v-if="currentStep == 1" style="background: #fff7e430;border: 0.5px solid #FFECBC;border-radius: 4px;margin-top: 60px;">
      <dl>
        <dt>为什么要进行身份验证？</dt>
        <dd>1.为保障您的账号信息安全,在变更账户中的重要信息时需要身份验证，感谢您的理解与支持。</dd>
        <dd>2.验证身份遇到问题?请提供用户名,手机号,历史发票,点击联系我司客服。</dd>
      </dl>
    </div>
    <div v-else >
      <template v-if="certMethod === 'mobile'" >
        <div style="background: #fff7e430;border: 0.5px solid #FFECBC;border-radius: 4px;margin-top: 60px;">
        <dl>
          <dt>没有收到短信验证码？</dt>
          <dd>1. 手机验证码存在延迟，可能需要2-3分钟才能收到，请稍后再试哦。</dd>
          <dd>2. 如2-3分钟后，仍未收到，请检查您的手机是否已停止服务，或拦截了我们的短信，或短信收件箱已满。</dd>
          <dd>3. 您可以尝试将SIM卡移动到另一部手机，然后重试，或者联系手机运营商咨询。</dd>
          <dd>4. 当手机丢失、停用或不在身边时，建议您更换其他验证方式。</dd>
        </dl>
      </div>
      </template>
      <template  v-if="certMethod === 'email'" >
        <div style="background: #fff7e430;border: 0.5px solid #FFECBC;border-radius: 4px;margin-top: 60px;">
          <dl>
            <dt>邮箱验证码收不到帮助：</dt>
            <dd>1.您的邮箱验证码可能需要10分钟才能到达您的注册邮箱（这取决于您的邮箱运营商），为避免系统错误请不要重复点击。</dd>
            <dd>2.请检查您的邮箱是否已停止服务或邮件是否流入垃圾箱或邮箱收件箱已满。</dd>
            <dd>3.网络异常可能导致邮件丢失，请您重新点击“获取验证码”或稍后使用不同的浏览器或清除浏览器缓存重试。</dd>
            <dd>4.您也可以联系您的邮箱运营，查看验证码邮件是否被他们拦截封锁。</dd>
          </dl>
        </div>
    </template>
    </div>
  </div>
</template>

<script>
import ThrottleBtn from '@/components/common/ThrottleBtn.vue'

export default {
  name: 'CertForm',
  components: {
    ThrottleBtn
  },
  props: {
    certType: {
      type: String,
      required: false
    },
    hasImgCode: {
      type: Boolean,
      required: false,
      default: false
    },
    isInputMobile: {
      type: Boolean,
      required: false,
      default: false
    },
    source:{
        type: String,
        default: ''
    }
  },
  data() {
    return {
      currentStep: 1,
      certMethod: 'mobile',
      certMethods: [
        {
          label: '手机验证码验证',
          value: 'mobile'
        },
        {
          label: '邮箱验证',
          value: 'email'
        },
        {
          label: '密保问题验证',
          value: 'question'
        }
      ],
      rules: {
        mobile: [
          { required: true, message: '请输入手机号码', trigger: ['blur', 'change'] },
          { validator: this.$validate.mobile, trigger: ['blur', 'change'] }
        ],
        smsCode: [
          { required: true, message: '请输入短信验证码', trigger: ['blur', 'change'] },
        ],
        imgCode: [
          { required: true, message: '请输入图片验证码', trigger: ['blur', 'change'] },
        ],
        emailCode: [
          { required: true, message: '请输入邮箱验证码', trigger: ['blur', 'change'] },
        ],
        'answer1': [
          { required: true, message: '请输入密保答案1', trigger: ['blur', 'change'] },
        ],
        'answer2': [
          { required: true, message: '请输入密保答案2', trigger: ['blur', 'change'] },
        ],
        'answer3': [
          { required: true, message: '请输入密保答案3', trigger: ['blur', 'change'] },
        ],
      },
      certForm: {
        mobile: '',
        email: '',
        smsCode: '',
        imgCode: '',
        emailCode: '',
        answer1: '',
        answer2: '',
        answer3: '',
      },
      questionList: [],
      userInfo: [],
      personalInfo: [],
      imgCode: '',
      imgKey: ''
    }
  },
  created() {
    let _this = this;
    _this.changeImgCode();
    _this.$util.api('/member/info', {}, function (res) {
      if (res.code == 10000) {
        _this.personalInfo = res.data;
        if (!_this.isInputMobile){
          _this.certForm.mobile = _this.personalInfo.mobile;
          _this.certForm.email = _this.personalInfo.email;
        }
      }
    });
  },
  methods: {
    changeImgCode() {
      this.certForm.imgCode = ''
      this.getImgCode()
    },
    getImgCode() {
      var _this = this;

      let imgCode = '';

      _this.$util.api('/code', {}, function (res) {
        if (res.code == 10000) {
          imgCode = res.data.img;
          _this.imgCode = res.data.img;
          _this.imgKey = res.data.key
        }
      });

      return imgCode;
    },
    submit() {
      let _this = this;
      let fieldKeys = []
      switch (_this.certMethod) {
        case 'mobile':
          fieldKeys = ['smsCode']
          if (this.hasImgCode) {
            fieldKeys.push('imgCode')
          }
          break
        case 'email':
          fieldKeys = ['emailCode']
          if (this.hasImgCode) {
            fieldKeys.push('imgCode')
          }
          break
        case 'question':
          fieldKeys = ['answer1', 'answer2', 'answer3']
          break
      }
      let validateStatus = true
      this.$refs.certForm.validateField(fieldKeys, err => {
        if (err) validateStatus = false
      })

      if (!validateStatus) return

      let params = fieldKeys.reduce((tar, key) => {
        tar[key] = this.certForm[key]
        return tar
      }, {})

      let { mobile, email, smsCode, emailCode, imgCode } = _this.certForm
      switch (_this.certMethod) {
        case 'mobile':
          _this.$util.api('/check/sms',
            { mobile: mobile, sms_code: smsCode },
            function (res) {
              if (res.code == 10000) {
                if(res.data==mobile){
                  _this.$emit('checkSuccess');
                }else{
                  _this.$message.error('与手机号码不符');
                }
              } else {
                _this.$message.error(res.msg);
              }
            });
          break;
        case 'email':
          _this.$util.api('/email/check',
            { email: email, code: emailCode },
            function (res) {
              if (res.code == 10000) {
                if(res.data==email){
                  _this.$emit('checkSuccess');
                }else{
                  _this.$message.error('与邮箱地址不符');
                }

              } else {
                _this.$message.error(res.msg);
              }
            });
          break;
        case 'question':
          let question = [
            {
              question_id: _this.questionList[0].question_id,
              answer: _this.certForm.answer1
            },
            {
              question_id: _this.questionList[1].question_id,
              answer: _this.certForm.answer2
            },
            {
              question_id: _this.questionList[2].question_id,
              answer: _this.certForm.answer3
            }
          ]

          _this.$util.api('/member/question/validate',
            { question: question },
            function (res) {
              if (res.code == 10000) {
                _this.$emit('checkSuccess');
              } else {
                _this.$message.error(res.msg);
              }
            });
          break;
      }
    },
    toBindEmail() {
      this.$router.push('/bind/email')
    },
    toSetQuestion() {
      this.$router.push('/question')
    },
    changeCertMethods() {
      let _this = this;
      if (_this.certMethod === 'question' && this.questionList.length === 0) {
        _this.$util.api('/member/question/get', {}, function (res) {
          if (res.code == 10000) {
            _this.questionList = res.data;
          }
        });
      }
    },
    changeCert(type){
      this.currentStep = 0 ;
      this.$emit('checkSuccess',1);
      this.certMethod = type;
    },
    validateMobile() {
      this.$refs.certForm.validateField(['mobile'], err => {
        if (err) return this.$message.error('手机号码格式不正确');
      })
      this.sendSms()

    },
    validateEmail() {
      this.$refs.certForm.validateField(['email'], err => {
        if (err) return this.$message.error('邮件格式不正确');
      })
      this.sendEmail()

    },
    sendSms() {
      const { mobile, imgCode } = this.certForm;
      let _this = this;
      let param = { mobile: mobile };
      if (_this.hasImgCode) {
        param.code = imgCode + ',' + _this.imgKey;
        if (_this.certForm.imgCode == "") {
          _this.$message.error("图片验证码不能为空！");
          return
        }
      }
      _this.$util.api('/sms', param, function (res) {
        if (res.code == 10000 && res.data==_this.personalInfo.mobile) {
          _this.$refs.smsBtn.handleClick();
        } else {
          _this.$refs.smsBtn.cancel();
          _this.changeImgCode();
          _this.certForm.imgCode = '';
          _this.$message.error(res.msg);
        }
      })
    },
    sendEmail() {
      let _this = this;
      const { email, imgCode } = _this.certForm;
      let param = { email: email };
      if (_this.hasImgCode) {
        param.code = imgCode + ',' + _this.imgKey;
        if (_this.certForm.imgCode == "") {
          _this.$message.error("图片验证码不能为空！");
          return
        }
      }
      _this.$util.api('/email/code', param, function (res) {
        if (res.code == 10000 && res.data==_this.personalInfo.email) {
          // 成功，置灰按钮
          _this.$refs.emailBtn.handleClick();
        } else {
          _this.$refs.emailBtn.cancel();
          _this.changeImgCode();
          _this.certForm.imgCode = '';
          _this.$message.error(res.msg);
        }
      })
    },
  },
  watch: {
    certMethod: {
      handler(type) {
        if (type) this.certMethod = type
        this.changeCertMethods();
      },
      immediate: true
    }
  }
}
</script>


<style scoped>
.cert_form_wrapper {}

::v-deep .ant-select {
  width: 350px;
  /* height: 36px; */
}

::v-deep .ant-input {
  /* height: 36px; */
}

::v-deep .ant-btn {
  /* height: 36px; */
}

.btn_wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn_wrapper ::v-deep .ant-btn {
  min-width: 102px;
  /* height: 32px; */
  font-size: 14px;
}

dl {
    width: 100%;
    margin-top: 20px;
    align-self: flex-start;
    margin-left: 20px;
    margin-bottom: 15px
  }

dt {
  font-size: 16px;
  font-weight: bold;
  line-height: 22px;
  margin-bottom: 10px;
}

dd {
  font-size: 14px;
  line-height: 26px;
}

.img_code {
  border: 1px solid #d8d8d8;
  cursor: pointer;
}

.tip {
  width: 100%;
  text-align: center;
  margin-bottom: 20px;
}

.tip-title {
  font-weight: 400;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0;
  line-height: 22px;
}

.tip-img {
  width: 14px;
  height: 14px;
}

.method {
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0;
  line-height: 60px;
}

.check-btn {
  width: 500px;
  height: 60px;
  background: #FFFFFF;
  border: 1px solid #D8D8D8;
  border-radius: 4px;
  margin-bottom: 15px;
}

.check-btn.hover {
  border: 1px solid #FD5902;
}

/deep/ .ant-form{
  margin: 0 60px;
}



</style>



// WEBPACK FOOTER //
// src/components/user/account/CertForm.vue